<!-- vue快捷创建组件 -->
<template>
  <div>
      <el-upload
        :action="action"
        :list-type="listType"
        :limit="limit"
        :file-list="fileList"
        :core-prop="coreProp"

        :on-preview="onPreview"
        :on-remove="onRemove"
        :on-success="onSuccess"
        :before-upload="beforeUpload"

        :on-exceed="onExceed"
        >
        <i class="el-icon-upload" ></i>
      </el-upload>

      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt=""/>
      </el-dialog>
  </div>
</template>

<script>
  //附件操作api
  import ATT_API from '@/api/api_att';

  export default {
    name: "el-upload-e",
    props:{
      //文件上传的url
      action:{
        type: String,
        default:()=>{
          return process.env.API_ROOT + '/api-base/sysAtt/save';
        }
      },
      //图片列表类型
      listType:{
        type: String,
        default: ()=>{ return
        'picture'
        }
      },
      //限制上传的文件数量
      limit:{
        type : Number,
        default: ()=>{ return 1; }
      },
      //文件列表
      fileList:{
        type:Array,
        default: ()=>{ return []; }
      } ,
      //内置属性
      coreProp:{
        type:Object,
        default: ()=>{
          return {
            //该文件列表是否被改变过,如果被改变过则为true,反之为false
            isChange:false,
            //上传成功后的文件列表id
            fileIds:[]
          };
        }
      }
    },
    data() {
      return {
        dialogVisible:false,
        dialogImageUrl:''
      }
    },
    mounted(){

    },
    methods: {
      //文件上传成功触发函数
      onSuccess(res, file){
          if(res.code == 0){
              this.$message.success("上传成功");
              //将id更新到业务对象中
              this.coreProp.fileIds.push(res.att.id);
              //file 绑定id
              file.id = res.att.id;
              //文件被改变过
              this.coreProp.isChange = true;

          }else{
              this.$message.success("上传失败");
          }
          this.$emit("onSuccess",res,file);
      },
       //预览函数
      onPreview(file){
        //获取文件后缀名
        let suffix = "";
        let i = -1;
        //判断此文件是否为新上传的,如果是新上传的那么必有raw属性
        if(file.raw){
          i = file.raw.name.lastIndexOf(".");
          suffix = i > 0 ? file.raw.name.substring(i+1).toLowerCase() : "";
        } else if(file.url){
          i = file.url.lastIndexOf(".");
          suffix = i > 0 ? file.url.substring(i+1).toLowerCase() : "";
        }

        let re= /(gif|jpg|jpeg|bmp|png|ico|tif)/g;
        if(re.test(suffix)){
          //是图片
          this.dialogImageUrl = file.url;
          this.dialogVisible = true;
        }else if(!file.raw){
          //只有不是最新上传的,且非图片就进行下载
          //下载文件
          window.location.href = file.url;
        }


        this.$emit("onPreview",file);
      },
      //文件删除触发函数
      onRemove(file, flist){
        //获取该文件id
        if(file.id){
            this.fileList.forEach((o,i) =>{
              if(file.id == o.id){
                //处理fileList数组,删除指定项
                this.fileList.splice(i,1);
                //终止循环
                return false;
              }
            });

            // ATT_API.delAttById({
            //   id:file.id
            // }).then(res =>{
            //   if(res.code == 0){
            //     this.$message.success("删除成功");
            //     //重新更新现有文件id列表

            //   }else{
            //     this.$message.success("删除失败");
            //   }
            // });
			this.coreProp.fileIds = flist.map(function(item){
			  return item.id;
			});
			//文件被改变过
			this.coreProp.isChange = true;
        }
        this.$emit("onRemove",file, flist);
      },
       //文件上传前处理函数
      beforeUpload(file){
          const isLt2M = file.size / 1024 / 1024 < 5;

          if (!isLt2M) {
            this.$message.error('上传文件大小不能超过 5MB!');
            return false;
          }
          return this.$emit("beforeUpload",file);
      },
      //选择文件超过删除限制个数触发函数
      onExceed(files, fileList){
          //提示
          this.$message.error('最多只能上传'+this.limit+'个文件');
      }
    },
    watch: {
    },
  };
</script>




// WEBPACK FOOTER //
// src/components/common/elUploadE.vue